import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = ['shutdownWorkers'];

const shutdownWorkersQuery = async () => {
  return await request.get(
    `/Request/workers`,
    {},
    `При загрузке создателей отключений произошла ошибка`
  );
};

export const useShutdownWorkers = (options) =>
  useQuery(key, shutdownWorkersQuery, options);
